import React from "react";

interface KPIOverviewTradeTagsProps {
  trades: string[];
}

const MAX_VISIBLE_TRADES = 2;

const TAG_CLASS_NAME =
  "shrink-0 rounded bg-gray-100 px-1.5 py-0.5 text-xs text-gray-600 dark:bg-slate-700 dark:text-gray-300";

const KPIOverviewTradeTags: React.FC<KPIOverviewTradeTagsProps> = ({
  trades,
}) => {
  if (trades.length === 0) {
    return null;
  }

  const visibleTrades = trades.slice(0, MAX_VISIBLE_TRADES);
  const hiddenCount = trades.length - visibleTrades.length;

  return (
    <div
      className="flex min-w-0 items-center gap-1 overflow-hidden"
      title={trades.join(", ")}
    >
      {visibleTrades.map((trade) => (
        <span className={TAG_CLASS_NAME} key={trade}>
          {trade}
        </span>
      ))}
      {hiddenCount > 0 && (
        <span className={TAG_CLASS_NAME}>+{hiddenCount}</span>
      )}
    </div>
  );
};

export default KPIOverviewTradeTags;
